import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay", "content", "label", "toggle"]

  connect() {
    this.collapsed = localStorage.getItem("sidebar_collapsed") === "true"
    this.applyCollapse()
  }

  // Desktop: mostra/nascondi tutta la sidebar. La preferenza vive su <html>
  // (classe applicata da uno script inline nel <head>, prima del primo paint)
  // e in localStorage, così l'ultima scelta dell'utente sopravvive.
  toggleDesktop() {
    const hidden = document.documentElement.classList.toggle("sidebar-hidden")
    localStorage.setItem("sidebar_open", hidden ? "false" : "true")
  }

  // Desktop: toggle collapsed state
  toggle() {
    this.collapsed = !this.collapsed
    localStorage.setItem("sidebar_collapsed", this.collapsed)
    this.applyCollapse()
  }

  applyCollapse() {
    this.sidebarTarget.classList.toggle("collapsed", this.collapsed)
    this.contentTarget.classList.toggle("collapsed", this.collapsed)
    this.labelTargets.forEach(el => el.classList.toggle("hidden", this.collapsed))
    if (this.hasToggleTarget) {
      this.toggleTarget.classList.toggle("rotate-180", this.collapsed)
    }
  }

  // Mobile: open sidebar
  openMobile() {
    this.sidebarTarget.classList.add("mobile-open")
    this.overlayTarget.classList.remove("hidden")
  }

  // Mobile: close sidebar
  closeMobile() {
    this.sidebarTarget.classList.remove("mobile-open")
    this.overlayTarget.classList.add("hidden")
  }
}
